import { KAMBI_HOME_HASH_ROUTE } from '@core/Areas/KambiClient/constants'
import { appHistory } from '@core/Utils/routing/history'

export const navigateToSportsPath = () => {
  appHistory.push(KAMBI_HOME_HASH_ROUTE)
}
